import { render, staticRenderFns } from "./KnowledgeBaseLink.vue?vue&type=template&id=22cc39a0&scoped=true&"
import script from "./KnowledgeBaseLink.vue?vue&type=script&lang=ts&"
export * from "./KnowledgeBaseLink.vue?vue&type=script&lang=ts&"
import style0 from "./KnowledgeBaseLink.vue?vue&type=style&index=0&id=22cc39a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cc39a0",
  null
  
)

export default component.exports